// extracted by mini-css-extract-plugin
export default {"actions":"actions---Mjl2v","unassignAll":"unassignAll---tIkKX"};